<template>
  <van-popup
    class="popup_box"
    v-model:show="showValue"
    round
    :style="{ padding: '64px' }"
    @click-overlay="cancel"
    :transition-appear="true"
  >
    <div @click="cancel" class="popup_close close_center"><span></span></div>
    <div class="popup">
      <p
        class="title"
        v-html="
          $t('envelope.popup.title', {
            value: `${addNum} ${
              balance && balance.currencyAlias ? balance.currencyAlias : defaultCurrencyAlias()
            }`
          })
        "
      ></p>
      <ShareProgress :width="4.3" />
      <div class="desc" style="color: #9ca0ab; margin-top: 0.2rem" v-if="boostNames.length > 0">
        {{ boostNames.join(' ') }}
      </div>
      <div class="desc" v-if="boostNames.length > 0">{{ $t('envelope.popup.listDesc') }}</div>
      <div class="desc" v-else>{{ $t('envelope.popup.tips') }}</div>
      <div class="button" @click="onWitchDraw" v-if="reward && reward.status == 2">
        {{ $t('envelope.popup.withdraw') }}
      </div>
      <div class="button" @click="onShareTG" v-else>{{ $t('envelope.popup.share') }}</div>
    </div>
  </van-popup>
</template>

<script>
import { useEnvelopeStore } from '@/stores/envelope'
import { useUserStore } from '@/stores/user'
import { mapState } from 'pinia'
import ShareProgress from './ShareProgress.vue'
import { fillterLongUserName, defaultCurrencyAlias } from '@/utils/helper'
import { REPORT_EVENT, reportGtag } from '@/common/mgtag'
export default {
  name: 'BoostList',
  components: {
    ShareProgress
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    boostList: {
      type: Array,
      default: () => []
    },
    onShare: {
      type: Function,
      default: () => {}
    },
    onWitchDraw: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      showValue: false,
      progress: 60,
      isFinishGuide: true,
      addNum: 0,
      boostNames: []
    }
  },
  watch: {
    show(newValue) {
      if (this.showValue == newValue) {
        return
      }
      this.showValue = newValue
    },
    boostList(newValue) {
      this.addNum = 0
      this.boostNames = []
      for (let index = 0; index < newValue.length; index++) {
        const element = newValue[index]
        if (element.collectType > 1 && element.currency != 'VPS' && element.currency != 'BONUS') {
          this.addNum += Math.round(Number(element.amount) * 100) / 100
          if (this.boostNames.length < 3) {
            this.boostNames.push(fillterLongUserName(element.collectNickname || ''))
          }
        }
      }
    }
  },
  mounted() {
    this.showValue = this.show
    // this.addNum = 0
    // this.boostNames = []
    // this.boostList.forEach(element => {
    //   if (element.collectType > 1) {
    //     this.addNum += Math.round(Number(element.amount) * 100) / 100
    //     if (this.boostNames.length < 3) {
    //       this.boostNames.push(fillterLongUserName(element.collectNickname || ''))
    //     }
    //   }
    // });
  },
  computed: {
    ...mapState(useEnvelopeStore, ['reward']),
    ...mapState(useUserStore, ['userInfo', 'balance', 'isLogin'])
  },
  methods: {
    defaultCurrencyAlias,
    onShareTG() {
      reportGtag(REPORT_EVENT.ENVELOPE.POCKET_MONEY_Prompt_TG, 'click')
      this.onShare()
    }
  }
}
</script>

<style lang="scss" scoped>
.popup_box {
  width: 5rem;
  height: auto;
  margin: 0 auto;
  padding: 5% 0 5% 0 !important;
  overflow: visible !important;
  border: solid 0.04rem transparent;
  border-radius: 0.16rem;
  background-color: #f1f1f1;
  text-align: center;
  z-index: 100;

  .close_center {
    display: flex !important;
    margin-top: -0.5rem !important;
    justify-content: center;
    align-items: flex-start;
  }

  .popup_close {
    height: 0.8rem;
    width: 0.8rem;
    top: 0.5rem;
    text-align: center;
    position: absolute;
    display: block;
    z-index: 2;
    right: 0rem;

    span {
      display: inline-block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(45deg);
      margin-top: 0.355rem;
    }

    span::after {
      content: '';
      display: block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(-90deg);
    }
  }

  .popup {
    display: flex;
    justify-content: center;
    width: 5rem;
    height: auto;
    // min-height: 4.7rem;
    border-radius: 12px;
    display: block;
    padding: 2% 5% 0 5%;
    margin: 0 auto;
    font-size: 0.24rem;

    .title {
      width: 100%;
      height: 0.28rem;
      font-family: DroidSans-Bold;
      font-weight: bold;
      font-size: 0.3rem;
      color: #000000;
      line-height: 0.3rem;
      text-align: center;
      font-style: normal;
      text-transform: none;
      // margin-top: 0.43rem;
      margin-left: -0.25rem;
    }

    .desc {
      width: 4.38rem;
      height: 0.22rem;
      font-family: DroidSans;
      font-size: 0.2rem;
      color: #000000; //#9CA0AB;
      line-height: 0.3rem;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 0.2rem;
    }

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 4.4rem;
      height: 0.7rem;
      background: #336aea;
      border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
      margin-top: 0.5rem;
    }
  }
}
</style>
